module.exports = __webpack_public_path__ + "static/media/icon_microphone_r.1c45dc3f.svg";